import React from 'react';
import { Button, Dropdown, Space } from 'antd';
import { BulbOutlined, BulbFilled } from '@ant-design/icons';
import { useTheme } from 'contexts/ThemeContext';

const ThemeToggle = () => {
  const { theme, setThemeMode, isDark } = useTheme();

  const themeMenuItems = [
    {
      key: 'light',
      label: (
        <Space>
          <BulbOutlined style={{ color: '#ff6b35' }} />
          Light Theme
        </Space>
      ),
    },
    {
      key: 'dark',
      label: (
        <Space>
          <BulbFilled style={{ color: '#ff6b35' }} />
          Dark Theme
        </Space>
      ),
    },
  ];

  const handleMenuClick = ({ key }) => {
    setThemeMode(key);
  };

  return (
    <Dropdown
      menu={{ items: themeMenuItems, onClick: handleMenuClick }}
      placement="bottomRight"
      trigger={['click']}
    >
      <Button
        type="text"
        icon={isDark ? <BulbFilled /> : <BulbOutlined />}
        style={{
          color: 'var(--text-primary)',
          fontSize: '18px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        title={`Current theme: ${theme}. Click to change.`}
      />
    </Dropdown>
  );
};

export default ThemeToggle;

